module.exports = __webpack_public_path__ + "img/message-square-01.ce147ab9.svg";